import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui canonical class merger. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
